import { ThemeCategoryLinkModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';
import { httpClient } from 'utils/http';

class ThemeCategoryLinkService extends ApiService<ThemeCategoryLinkModel> {
        constructor() {
                super('themecategorylink');
        }

         
        async removeLink(themeid: number, categoryid: number): Promise<ThemeCategoryLinkModel> {
                const response = await httpClient.delete<ThemeCategoryLinkModel>(
                        '/api/themecategorylink',
                        {
                                data: {
                                        themeid,
                                        categoryid,
                                },
                        },
                );

                return response.data;
        }

         
        async addLink(item: Omit<ThemeCategoryLinkModel, 'id'>): Promise<ThemeCategoryLinkModel> {
                const response = await httpClient.post<ThemeCategoryLinkModel>(
                        '/api/themecategorylink',
                        item,
                );
                return response.data;
        }

         
        async updateLinks(items: Omit<ThemeCategoryLinkModel, 'id'>[]): Promise<ThemeCategoryLinkModel[]> {
                const response = await httpClient.put<ThemeCategoryLinkModel[]>(
                        '/api/themecategorylinks',
                        items,
                );
                return response.data;
        }
}

export default new ThemeCategoryLinkService();
